// plugins/scrollreveal.client.ts
import { defineNuxtPlugin } from '#app'
import { getCompatFeatures, resolveCompatLevel } from '@/utils/compatMode'

export default defineNuxtPlugin(async () => {
  try {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
    const ios = ua.match(/OS (\d+)_/i)
    if (ios && +ios[1] < 14) {
      return { provide: { scrollReveal: null } }
    }

    const features = getCompatFeatures(resolveCompatLevel())
    if (features.isActive && features.level <= 1) {
      return { provide: { scrollReveal: null } }
    }

    try {
      const mod = await import('scrollreveal')
      const createScrollReveal = mod.default
      const data = typeof createScrollReveal === 'function' ? createScrollReveal() : null
      return {
        provide: {
          scrollReveal: data,
        },
      }
    } catch {
      return { provide: { scrollReveal: null } }
    }
  } catch (e) {
    console.warn('[scrollreveal] plugin failed safe:', e)
    return { provide: { scrollReveal: null } }
  }
})
